import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import styled from '@emotion/styled';
import { SxProps } from '@mui/material';

const StyledRadio = styled(Radio)(() => ({
    color: 'black',
    '&.Mui-checked': {
        color: 'black',
    },
}));

interface RadioGroupTypes {
    value: string;
    label: string;
    defaultValue?: string;
}

interface RadioButtonProps {
    data: RadioGroupTypes[];
    alignItems: string;
    name?: string;
    setValue?: (value: string) => void;
    value?: string;
    disabled?: boolean;
    sx?: SxProps;
}

export default function RadioButtonsGroup({ data, alignItems, setValue, name, value, disabled, sx }: RadioButtonProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (setValue) setValue(value);
    };

    return (
        <FormControl component="fieldset" disabled={disabled}>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={value || data[0]}
                name={name}
                onChange={handleChange}
                sx={{ alignItems: alignItems, ...sx }}
            >
                {data.map((radio) => (
                    <FormControlLabel
                        key={radio.value}
                        value={radio.value}
                        control={<StyledRadio />}
                        label={radio.label}
                        // Native radio inputs fire `change` only when the checked value actually
                        // toggles — clicking an already-selected option is a real, deliberate user
                        // action but produces no onChange event at all. Callers that need to tell
                        // "the visual default" apart from "the user explicitly confirmed this
                        // choice" (see CreateBasket's Activation section) need that click too, so
                        // it is forwarded here as well. Idempotent for every other caller: clicking
                        // the already-selected option just re-invokes setValue with the same value.
                        // Gated on `disabled`: the label still receives clicks when the group is
                        // disabled (only the radio icon gets pointer-events: none).
                        onClick={() => {
                            if (!disabled && setValue) setValue(radio.value);
                        }}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
}
